export default "__VITE_ASSET__BkXn6zcs__"